import { SOFT_HYPHEN } from 'constants/string';

import { productTypeIcons } from 'shared/assets/icons/productType';

import { PRODUCT_TYPE_TAB_PAYLOADS, type TProductTypeTabId } from 'entities/creditForm';

import type { TProductTypeTabConfig, TProductTypeTab } from '../types';

const PRODUCT_TYPE_TAB_UI: Record<
  TProductTypeTabId,
  Pick<TProductTypeTab, 'title' | 'subtitle' | 'subtitleDesktop'>
> = {
  cash: {
    title: 'Кредит наличными',
    subtitle: 'на любые цели',
    subtitleDesktop: 'на любые цели',
  },
  creditCard: {
    title: 'Кредитная карта',
    subtitle: 'с льготным периодом',
    subtitleDesktop: 'с льготным периодом',
  },
  microCredit: {
    title: 'Займ',
    subtitle: 'деньги через 10 минут',
    subtitleDesktop: 'деньги на карте через 10 минут',
  },
  refinance: {
    title: `Рефинансиро${SOFT_HYPHEN}вание`,
    subtitle: 'по текущим кредитам',
    subtitleDesktop: 'по текущим кредитам',
  },
};

export const PRODUCT_TYPE_TABS: TProductTypeTab[] = PRODUCT_TYPE_TAB_PAYLOADS.map((payload) => ({
  ...payload,
  ...PRODUCT_TYPE_TAB_UI[payload.id],
}));

const PRODUCT_TYPE_TAB_ICONS: Record<TProductTypeTabId, TProductTypeTabConfig['icon']> = {
  cash: productTypeIcons.cash,
  creditCard: productTypeIcons.creditCard,
  microCredit: productTypeIcons.microCredit,
  refinance: productTypeIcons.refinance,
};

export const PRODUCT_TYPE_TAB_ITEMS: TProductTypeTabConfig[] = PRODUCT_TYPE_TABS.map((tab) => ({
  ...tab,
  icon: PRODUCT_TYPE_TAB_ICONS[tab.id],
}));
